// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { SiteByCpcode } = initSchema(schema);

export {
  SiteByCpcode
};